import React from "react";

import TopNav from "../components/TopNav";
import "./CommunityPage.css";

const CommunityPage = (props) => {
    const isDarkMode = Boolean(props.darkmode);

    return(
        <React.Fragment>
            <TopNav page={props.page} darkMode={props.darkmode} />

            <main className={`community-page ${isDarkMode ? "is-dark" : "is-light"}`}>
                <header className="community-hero" aria-labelledby="community-title">
                    <div className="community-hero__content">
                        <p className="community-hero__eyebrow">FDXVA Community Hub</p>
                        <h1 id="community-title" className="community-hero__title">Forums and Events</h1>
                        <p className="community-hero__subtitle">
                            Find out about all the events and happenings at FDXVA on our Discord server, where you can also
                            chat with other pilots and staff, post questions and get answers. We hope you enjoy your time with us.
                        </p>
                        <div className="community-hero__cta" role="group" aria-label="Discord community links">
                            <a className="community-button" target="_blank" rel="noreferrer" href="https://discord.gg/7sSJDZe">
                                Invite Code: 7sSJDZe
                            </a>
                            <a className="community-button community-button--ghost" target="_blank" rel="noreferrer" href="https://discord.gg/7sSJDZe">
                                Click here to join us!
                            </a>
                        </div>
                    </div>

                </header>

                <section className="community-grid" aria-label="Community highlights">
                    <article className="community-card">
                        <div className="community-card__header">
                            <span className="community-card__icon" aria-hidden="true">
                                🧭
                            </span>
                            <h2 className="community-card__title">Discord Community</h2>
                        </div>
                        <p className="community-card__body">
                            Stay connected with pilots, staff, and event coordinators. Enjoy curated channels for flights,
                            training, announcements, and social updates.
                        </p>
                        <div className="community-card__footer">
                            <span className="community-card__chip">Always online</span>
                            <span className="community-card__chip">Real-time support</span>
                        </div>
                    </article>

                    <article className="community-card">
                        <div className="community-card__header">
                            <span className="community-card__icon" aria-hidden="true">
                                📡
                            </span>
                            <h2 className="community-card__title">Events & Fly-Ins</h2>
                        </div>
                        <p className="community-card__body">
                            Join seasonal fly-ins, group challenges, and networked operations. Coordinate with dispatch and
                            share flight plans across time zones.
                        </p>
                        <div className="community-card__footer">
                            <span className="community-card__chip">Weekly ops</span>
                            <span className="community-card__chip">Community awards</span>
                        </div>
                    </article>

                    <article className="community-card">
                        <div className="community-card__header">
                            <span className="community-card__icon" aria-hidden="true">
                                🧑‍✈️
                            </span>
                            <h2 className="community-card__title">Training & Mentorship</h2>
                        </div>
                        <p className="community-card__body">
                            Connect with instructors and fellow pilots for training sessions, platform tips, and operational
                            best practices tailored to every rank.
                        </p>
                        <div className="community-card__footer">
                            <span className="community-card__chip">Flight ready</span>
                            <span className="community-card__chip">Mentor-led</span>
                        </div>
                    </article>
                </section>

                <section className="community-embed" aria-label="Discord widget">
                    <div className="community-embed__header">
                        <div>
                            <h2 className="community-embed__title">Live Discord Feed</h2>
                            <p className="community-embed__subtitle">Join the conversation and never miss an update.</p>
                        </div>
                        <span className="community-embed__badge" aria-hidden="true">Live</span>
                    </div>
                    <div className="community-embed__frame">
                        <iframe
                            title="FDXVA Discord Widget"
                            src="https://discordapp.com/widget?id=347743643198554112&theme=dark"
                            allowTransparency={true}
                            frameBorder="0"
                        ></iframe>
                    </div>
                </section>
            </main>
        </React.Fragment>)
}
export default CommunityPage;
